module.exports = __webpack_public_path__ + "img/tick.2fe8374b.svg";